import { Button, DatePicker } from '@fullscreendigital/carrefour-dex-fe'
import { Grid } from '@mui/material'
import { AsyncAutocomplete } from 'components/core-ui/AsyncAutocomplete'
import { Modal } from 'components/core-ui/Modal'
import { getLocationOptions } from 'components/waste-management/api'
import { useNotification } from 'hooks'
import s from 'components/core-ui/Modal/Modal.modules.scss'
import { BulkDownloadModalProps } from 'components/waste-management/interfaces'
import { ImmerState } from 'immer/dist/internal'

const BulkDownloadModal = (props: BulkDownloadModalProps) => {
  const { isModalOpen, closeModal, filters, setFilters, downloadBulkDocuments } = props

  const { showNotification } = useNotification()

  const { data: locationOptions } = getLocationOptions(showNotification)

  const updateFilters = (name: string, value: string | AutocompleteOption | Date) => {
    setFilters((draft: ImmerState) => {
      draft[name] = value as never
    })
  }

  const cancelModal = () => {
    setFilters({
      locations: [],
      startDate: null,
      endDate: null
    })
    closeModal()
  }

  return (
    <Modal isModalOpen={isModalOpen} closeModal={cancelModal} modalTitle="Descarca documente">
      <Grid container spacing={4}>
        <Grid xs={12} item>
          <AsyncAutocomplete
            variant="outlined"
            name="locations"
            label="Locatii"
            value={filters.locations}
            options={locationOptions || []}
            onChange={value => updateFilters('locations', value)}
            multiple
          />
        </Grid>
        <Grid xs={12} md={6} item>
          <DatePicker
            label="Data inceput"
            onChange={value => updateFilters('startDate', value)}
            variant="outlined"
            value={filters.startDate}
            style={{ width: '100%' }}
            required
          />
        </Grid>
        <Grid xs={12} md={6} item>
          <DatePicker
            label="Data sfarsit"
            onChange={value => updateFilters('endDate', value)}
            variant="outlined"
            value={filters.endDate}
            style={{ width: '100%' }}
            required
          />
        </Grid>
        <Grid xs={12} item className={s.modalButtons}>
          <Button variant="outlined" label="Anuleaza" onClick={cancelModal} />
          <Button
            variant="contained"
            type="submit"
            label="Descarca"
            onClick={downloadBulkDocuments}
          />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default BulkDownloadModal
